<template>

  <Form
    :title="$t('Apply fields')"
    :creating="creating"
    :loading="loading">
    <form
      id="applyfields-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveApplyfields(applyfields)">

      <table
        class="table table-bordered"
        style="width: auto">
        <thead>
          <tr>
            <th scope="col">{{ $t('Field') }}</th>
            <th scope="col">{{ $t('Application') }}</th>
            <th scope="col">{{ $t('Recommendation') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in applyfields"
            :key="index">
            <th scope="row">{{ item.name }}</th>
            <td>
              <AccountApplyfieldsSelect
                v-model="applyfields[index]"
                type="application"
                :hasRequired="item.has_required" />
            </td>
            <td>
              <AccountApplyfieldsSelect
                v-model="applyfields[index]"
                type="referral"
                :hasRequired="item.has_required" />
            </td>
          </tr>
        </tbody>
      </table>

    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="applyfields-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'
import AccountApplyfieldsSelect from './AccountApplyfieldsSelect'

export default {
  name: 'AccountApplyfields',
  components: {
    Form,
    AccountApplyfieldsSelect
  },
  data () {
    return {
      creating: true,
      loading: false,
      teste: null,
      applyfields: [
        {name: this.$t('Intended position'), field: 'headline', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Photo'), field: 'photo', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Address'), field: 'address', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Disability'), field: 'disability', application: 'hidden', referral: 'hidden', has_required: false},
        {name: this.$t('Birth date'), field: 'birth_date', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Qualifications summary'), field: 'summary', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Gender'), field: 'gender', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Resume (file)'), field: 'resume', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Salary'), field: 'salary', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Professional category'), field: 'position_category', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Experience level'), field: 'experience_level', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Educations'), field: 'educations', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Experiences'), field: 'experiences', application: 'hidden', referral: 'hidden', has_required: true},
        {name: this.$t('Pages (Social Networks)'), field: 'pages', application: 'hidden', referral: 'hidden', has_required: false},
        {name: this.$t('Languages'), field: 'languages', application: 'hidden', referral: 'hidden', has_required: false}
      ],
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountApplyfields', this.account._id)
      .then(result => {
        result.applyfields.forEach(value => {
          const index = this.applyfields.findIndex(v => v.field === value.field)
          if (index >= 0) {
            this.applyfields[index] = {
              ...this.applyfields[index],
              ...value
            }
          }
        })
        this.creating = false
      })
    },
    saveApplyfields (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountApplyfields', {
        _id: this.account._id,
        applyfields: data
      })
      .then(() => {
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    setValue (index, type, value) {
      this.$set(this.applyfields[index], type, value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountApplyfields.vue